import React from 'react'
import { Helmet } from 'react-helmet'

import { Home as HomeImages } from 'config/images'
import { HomeVideo } from 'config/videos'

import {
	HeaderContainer,
	HeaderContent,
	HeaderLeftColumn,
	HeaderTitle,
	HeaderCopy,
	HeaderLink,
	HeaderRightColumn,
	HeaderImage,
	BodyContainer,
	BodyContent,
	BodyRow,
	BodyRowLeftColumn,
	BodyRowImageSmall,
	BodyRowImage,
	BodyRowRightColumn,
	BodyRowTitle,
	BodyRowCopy,
	BodyRowLink,
	BodyVideoWrapper,
	BodyVideo,
	TrustedContainer,
	TrustedContent,
	TrustedTitle,
	TrustedLogoRow,
	TrustedLogoTall,
	TrustedLogo,
	DigitizeContainer,
	DigitizeContent,
	DigitizeLeftColumn,
	DigitizeTitle,
	DigitizeCopy,
	DigitizeList,
	DigitizeListItem,
	DigitizeRightColumn,
	DigitizeImage,
} from './styledComponents'

export const Home = () => {
	const meta = {
		title: 'RCMS Software',
		description: 'Standardizing, Digitizing, and Automating',
	}

	return (
		<>
			<Helmet {...meta} />
			<HeaderContainer>
				<HeaderContent>
					<HeaderLeftColumn>
						<HeaderTitle>
							Plug & Play Back Office Platform for Road Construction Contractors &
							Vendors.
						</HeaderTitle>
						<HeaderCopy>
							Monitor, manage your business, simplify your bookkeeping, engage with
							your customers and streamline your operations decreasing your
							unnecessary overhead and increasing profits.
						</HeaderCopy>
						<div>
							<HeaderLink to='/product'>Learn More</HeaderLink>
						</div>
					</HeaderLeftColumn>
					<HeaderRightColumn>
						<HeaderImage
							src={HomeImages.headerTablet}
							alt='RCMS Software on a tablet'
						/>
					</HeaderRightColumn>
				</HeaderContent>
			</HeaderContainer>
			<BodyContainer>
				<BodyContent>
					<BodyRow>
						<BodyRowLeftColumn>
							<BodyRowImageSmall src={HomeImages.quickbooks} alt='Quickbooks' />
						</BodyRowLeftColumn>
						<BodyRowRightColumn>
							<BodyRowTitle>A Certified QuickBooks Partner</BodyRowTitle>
							<BodyRowCopy>
								RCMS also comes equipped with a team of CPA’s with Industry
								experience to handle all of our bookkeeping so you can focus on the
								revenue-generating tasks that help grow your business!
							</BodyRowCopy>
							<BodyRowLink to='/contact'>
								Request a Free 1 Hour Consultation
							</BodyRowLink>
						</BodyRowRightColumn>
					</BodyRow>
					<BodyRow>
						<BodyRowLeftColumn>
							<BodyRowImage
								src={HomeImages.bodyTablet}
								alt='RCMS Software on a tablet'
							/>
						</BodyRowLeftColumn>
						<BodyRowRightColumn>
							<BodyRowTitle>
								The First EVER complete end to end solution!
							</BodyRowTitle>
							<BodyRowCopy>
								The Traffic Control space is unique. We understood that your typical
								off the shelf "CRM" just wasn't cutting it for businesses in this
								industry. That is why we developed RCMS. RCMS is backed and was
								carefully constructed by some of the most successful Traffic Control
								leaders in the industry. RCMS is the FIRST true end to end solution
								that will help every operator streamline their business. From
								Rentals to Contract projects, RCMS is there to help automate your
								invoicing, billing, purchase orders, equipment tracking, fleet, etc.
							</BodyRowCopy>
						</BodyRowRightColumn>
					</BodyRow>
				</BodyContent>
			</BodyContainer>
			<BodyVideoWrapper>
				<BodyVideo playsInline loop autoPlay muted controls>
					<source src={HomeVideo} type='video/mp4' />
				</BodyVideo>
			</BodyVideoWrapper>
			<TrustedContainer>
				<TrustedContent>
					<TrustedTitle>Trusted by Leading Contractors & Associations</TrustedTitle>
					<TrustedLogoRow>
						<TrustedLogo src={HomeImages.atssa} alt='ATSSA' />
						<TrustedLogo src={HomeImages.d2k} alt='D2k Traffic Control' />
						<TrustedLogoTall
							src={HomeImages.roadBuilders}
							alt='Illinois Road and Transportation Builders Association'
						/>
						<TrustedLogo src={HomeImages.quickbooks} alt='Quickbooks' />
						<TrustedLogo
							src={HomeImages.directTraffic}
							alt='Direct Traffic Control Inc.'
						/>
					</TrustedLogoRow>
				</TrustedContent>
			</TrustedContainer>
			<DigitizeContainer>
				<DigitizeContent>
					<DigitizeLeftColumn>
						<DigitizeTitle>
							The Fastest Way to Digitize Your Back Office & Business Operations
						</DigitizeTitle>
						<DigitizeCopy>
							Plug & Play End to End platform with various modules specifically
							designed for your business.
						</DigitizeCopy>
						<DigitizeList>
							<DigitizeListItem>TICKETS</DigitizeListItem>
							<DigitizeListItem>CONTRACTS</DigitizeListItem>
							<DigitizeListItem>RENTALS</DigitizeListItem>
							<DigitizeListItem>TIMESHEET</DigitizeListItem>
							<DigitizeListItem>EQUIPMENT TRACKING</DigitizeListItem>
							<DigitizeListItem>PURCHASE REQUISITIONS</DigitizeListItem>
							<DigitizeListItem>ACCOUNTING</DigitizeListItem>
						</DigitizeList>
					</DigitizeLeftColumn>
					<DigitizeRightColumn>
						<DigitizeImage
							src={HomeImages.devicesNoShadow}
							alt='RCMS Software on all devices'
						/>
					</DigitizeRightColumn>
				</DigitizeContent>
			</DigitizeContainer>
		</>
	)
}
